<template>
  <div class="list-view">
    <van-swipe-cell>
      <van-form>
        <div class="idcard-box">
          <div class="carimg-box" v-show="isShowFiled('urlCardFront')">
            <div
              class="img-item"
              v-if="$ComTools.isEmptyString(people.urlCardFront)"
              @click="handleUploadClick(1)"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/imgs/upload/id_card_front.png') +
                  ')',
              }"
            ></div>
            <div class="view-item" @click="handleUploadClick(1)" v-else>
              <img
                :src="
                  $ComTools.isEmptyString(people.urlCardFront)
                    ? imgCardFrontBase64
                    : '/api/file/' + people.urlCardFront
                "
              />
            </div>
            <input
              type="file"
              ref="rfile1"
              @change="handleUploadChange($event, 1)"
              multiple
              style="display: none"
              accept="image/*"
            />
          </div>
          <div class="carimg-box" v-show="isShowFiled('urlCardVerso')">
            <div
              class="img-item"
              v-if="$ComTools.isEmptyString(people.urlCardVerso)"
              @click="handleUploadClick(2)"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/imgs/upload/id_card_verso.png') +
                  ')',
              }"
            ></div>
            <div class="view-item" @click="handleUploadClick(2)" v-else>
              <img
                :src="
                  $ComTools.isEmptyString(people.urlCardVerso)
                    ? imgCardVersoBase64
                    : '/api/file/' + people.urlCardVerso
                "
              />
            </div>
            <input
              type="file"
              ref="rfile2"
              @change="handleUploadChange($event, 2)"
              multiple
              style="display: none"
              accept="image/*"
            />
          </div>
        </div>
        <div v-for="item in fieldJson" :key="item.key" class="filed-box">
          <van-field
            v-if="item.type == '2'"
            readonly
            clickable
            :required="item.required == '1'"
            :label="item.name"
            :value="item[item.key + '_name']"
            :placeholder="item.placeholder"
            @click="handleShowPicker(item)"
          />
          <van-field
            :required="item.required == '1'"
            v-else-if="
              item.key != 'urlCardFront' &&
              item.key != 'urlCardVerso' &&
              item.key != 'urlBankCard' &&
              item.type == '1'
            "
            v-model="people[item.key]"
            :label="item.name"
            :placeholder="item.placeholder"
            @input="handleInputClick($event, item.key)"
          />
        </div>
        <van-field name="switch" label="设为投保人" required v-if="single != 1">
          <template #input>
            <van-switch
              v-model="people.holderFlag"
              @change="handleChangeClick"
              size="20"
            />
          </template>
        </van-field>
      </van-form>
      <template #right>
        <van-button
          v-if="num > 1"
          square
          type="danger"
          text="删除"
          style="height: 100%"
          @click="handleDelClick"
        />
        <van-button
          v-else
          square
          color="gray"
          text="删除"
          style="height: 100%"
          @click="handleUnDelClick"
        />
      </template>
    </van-swipe-cell>
    <van-popup v-model="showCommonPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="commonList"
        @confirm="handlePickerOk"
        @cancel="handleClosePicker"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import { uploadIdCard, getBank } from "@/api/common";
import { isCard } from "@/utils/validate";
export default {
  props: {
    people: {
      type: Object,
      default: () => {
        return {};
      },
    },
    num: {
      type: Number,
      default: 0,
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    fieldJson: {
      type: Array,
      default: [],
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dictionaryList: {
      type: Array,
      default: [],
    },
    single: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    people: {
      handler: function (val, oldVal) {
        if (
          !this.$ComTools.isEmptyString(val.insureIdNo) &&
          !this.$ComTools.isEmptyString(val.insureName) &&
          !this.$ComTools.isEmptyString(val.insureAddress)
        ) {
          this.$emit("historys", val, this.itemIndex);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      imgCardVersoBase64: "",
      imgCardFrontBase64: "",
      imgCardBankBase64: "",
      showUploadLoading: false,
      switchChecked: false,
      showCommonPicker: false,
      currentItem: {},
      commonList: [],
    };
  },
  methods: {
    handleShowPicker(item) {
      this.currentItem = item;
      this.showCommonPicker = true;
      let aArray = [];
      for (let i = 0; i < this.dictionaryList.length; i++) {
        let obj = this.dictionaryList[i];
        if (obj.code == item.dictionaryValue) {
          aArray.push(obj);
        }
      }
      this.commonList = aArray;
    },
    handleClosePicker() {
      this.currentItem = {};
      this.showCommonPicker = false;
      this.commonList = [];
    },
    handlePickerOk(a) {
      this.currentItem[this.currentItem.key + "_name"] = a.name;
      this.people[this.currentItem.key] = a.value;
      this.handleClosePicker();
      this.$forceUpdate();
    },
    handleDelClick() {
      this.$emit("delChild", this.itemIndex);
    },
    handleUnDelClick() {
      Toast("最后一个禁止删除");
    },
    isShowFiled(key) {
      let flag = false;
      for (let i = 0; i < this.fieldJson.length; i++) {
        let row = this.fieldJson[i];
        if (row.key == key) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    handleUploadClick(index) {
      switch (index) {
        case 1:
          this.$refs.rfile1.click();
          break;
        case 2:
          this.$refs.rfile2.click();
          break;
      }
    },
    handleInputClick(e, key) {
      if (key == "insureIdNo")
        if (isCard(e)) {
          this.$emit("showCategory", e);
        }
    },
    // 压缩前将file转换成img对象
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
        };
        reader.onerror = function (e) {
          reject(e);
        };
        reader.readAsDataURL(file);
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (e) {
          reject(e);
        };
      });
    },
    /**
     * 压缩图片
     *@param img 被压缩的img对象
     * @param type 压缩后转换的文件类型
     * @param mx 触发压缩的图片最大宽度限制
     * @param mh 触发压缩的图片最大高度限制
     */
    compressImg(img, type, mx, mh) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const { width: originWidth, height: originHeight } = img;
        // 最大尺寸限制
        const maxWidth = mx;
        const maxHeight = mh;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            // 宽图片
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            // 高图片
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, type || "image/png");
      });
    },
    async handleUploadChange(e, index) {
      let oFile = e.target.files[0];
      let iSize = parseInt(oFile.size / 1024 / 1024);
      const img = await this.readImg(oFile);
      const blob = await this.compressImg(img, oFile.type, 1080, 1920);
      let files = new window.File([blob], oFile.name, { type: oFile.type });
      oFile = files;
      let fd = new FormData();
      fd.append("file", oFile);
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      var reader = new FileReader();
      reader.readAsDataURL(oFile);
      reader.onload = (e) => {
        switch (index) {
          case 1:
            this.imgCardFrontBase64 = e.target.result;
            break;
          case 2:
            this.imgCardVersoBase64 = e.target.result;
            break;
          case 3:
            this.imgCardBankBase64 = e.target.result;
            break;
        }
      };
      let mfunction = uploadIdCard;
      if (index == 3) {
        mfunction = getBank;
      }
      mfunction(fd).then((res) => {
        Toast.clear();
        switch (index) {
          case 1:
            this.people.urlCardFront = res.data.url;
            let oResult = res.data.result;
            if (!this.$ComTools.isEmptyString(oResult)) {
              this.people.insureIdNo = oResult.number;
              this.people.insureName = oResult.name;
              //this.people.insureSex = oResult.sex == "女" ? "2" : "1";
              this.people.insureAddress = oResult.address;
              this.people.insureIdNo = oResult.number;
              this.$emit("showCategory", oResult.number);
            }
            this.$refs.rfile1.value = null;
            break;
          case 2:
            this.people.urlCardVerso = res.data.url;
            this.$refs.rfile2.value = null;
            break;
          case 3:
            this.people.urlBankCard = res.data.url;
            this.people.bankCardNumber = oResult.card_number;
            this.people.validDate = oResult.expiry_date;
            this.people.bankCardType = oResult.type;
            this.people.bankName = oResult.bank_name;
            break;
        }
      });
    },
    handleChangeClick(val) {
      this.$emit("setInsure", val, this.itemIndex);
    },
    setSwitchInsure(flag) {
      this.people.holderFlag = flag;
    },
    handleValidate(item) {
      return new Promise((resolve, reject) => {
        let flag = true;
        let sMsg = "";
        for (let i = 0; i < this.fieldJson.length; i++) {
          let row = this.fieldJson[i];
          let sKey = row.key;
          let sRequired = row.required;
          if (sRequired == "1") {
            let sValue = this.people[sKey];
            if (this.$ComTools.isEmptyString(sValue)) {
              flag = false;
              sMsg = row.placeholder;
              break;
            }
          }
        }
        if (flag) {
          let oTmp = {};
          for (let i = 0; i < this.fieldJson.length; i++) {
            let obj = this.fieldJson[i];
            if (obj.systemField == 0) {
              oTmp[obj.key] = this.people[obj.key];
            }
          }
          this.people["extraJson"] = JSON.stringify(oTmp);
          resolve({
            flag: flag,
            data: this.people,
            binsure: this.people.holderFlag,
          });
        } else {
          resolve({ flag: flag, msg: sMsg, binsure: this.people.holderFlag });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.idcard-box {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.carimg-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42%;
  .img-item {
    width: 100%;
    height: 96px;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-size: 100% 100%;
  }
  .view-item {
    width: 100%;
    height: 96px;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .option-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 20px;
        color: red;
        display: none;
        cursor: pointer;
      }
      &:hover i {
        display: block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/tb_form_item.vue